<template>
	<Slider :sliders="sliders"></Slider>
</template>

<script>
import Slider from "@/components/Pages/CategorySlider";

export default {
	components: { Slider },

	data() {
		return {
			sliders: [
				{
					title: "Aerosol",
					name: "Aerosol Acuario",
					color: "#18589C",
					product_id: 13,
					img: "/img/aacuario.png",
					description:
						"Es un esmalte acrílico de calidad Premium en presentación de aerosol con un excelente acabado, desempeño y secado rápido que facilita el desarrollo de todos tus proyectos.",
				},

				{
					title: "Aerosol",
					name: "AG Racing Turbo",
					color: "#676767",
					product_id: 14,
					img: "/img/aturbo.png",
					description:
						"Es el mejor esmalte acrílico en presentación de aerosol dentro del mercado, entre sus beneficios cuenta con secado rápido y excelente resistencia a la intemperie.",
				},

				{
					title: "Aerosol",
					name: "Spray Master",
					color: "#020001",
					product_id: 15,
					img: "/img/aspraymaster.png",
					description:
						"Esmalte acrílico en presentación de aerosol es ideal para facilitar el desarrollo de todos tus proyectos gracias a su secado rápido y excelente resistencia a la intemperie.",
				},
			],
		};
	},
};
</script>

<style lang="css" scoped></style>
